// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getUsers: '/catalog/user',
  opUsers: '/catalog/user',
}

// get Users
export async function getUsers(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getUsers
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`
        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo usuarios',
        description: error.message,
      })
    })
}

export async function putUser(token, user) {
  const url = fsConfig.root + fsConfig.opUsers
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  const { key } = user
  delete user.key
  delete user.suscription
  return axios
    .put(url, user, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      response.key = key
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error grabando usuario',
        description: error.message,
      })
    })
}

export async function deleteUser(token, userUid) {
  const url = `${fsConfig.root}${fsConfig.opUsers}/${userUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando usuario',
        description: error.message,
      })
    })
}
